import type { UpdateCompanyNameCommandData } from '@festina/legalentity-general-types/legalentity'
import { typeUtils } from '@festina-life/core'
import { FormikForm, FormikTextInput } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import type { CommandDataFormProps } from '../../commandActions/CommandDataFormAndSimulation'

const validateKey = typeUtils.createValidator<UpdateCompanyNameCommandData>()

export const UpdateCompanyNameForm = (
  props: CommandDataFormProps<UpdateCompanyNameCommandData>,
) => {
  const translate = useTranslate()

  return (
    <FormikForm
      initialValues={{ _type: 'UpdateCompanyNameCommandData' }}
      {...props}
    >
      <FormikTextInput
        name={validateKey('name')}
        label={translate('updateCompanyName.name')}
      />
    </FormikForm>
  )
}
